import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Header from '../layout/header/header';
import SideNavigationPanel from '../layout/header/sideNavigationPanel';
import { ClickAwayListener, Drawer, Grid, Paper, Popper, Typography, useMediaQuery, } from '@mui/material';
import { Outlet, useSearchParams } from 'react-router-dom';
import globalStyles from "../../assets/styles/global.module.scss";
import { UserContext, UserContextPayload } from '../../context/userContext';
import IconsColor from '../utility/iconsColor';
import closeArrow from "../../assets/closeArrow.png";
import Support from '../utility/support';
import { IntegrationContext, IntegrationContextPayload } from '../../context/integrationContext';
import whatsappIcon from '../../assets/Whatsapp.svg'
import facebookMessenger from '../../assets/chatbotAssets/facebookMessenger.svg'
import instagramIcon from '../../assets/images/channels/instagram/instagram.png'
import { ConsultationComponent } from '../utility/consult';
import { flagShowGetStartedPage, getStartedPageObj, getWabaName, isNewUser, isOrganizationRoleAgent, menuItemsJunagadh, menuItemsMawhiba, menuItemsTimSafransky, publicAgentMenuItems, usePublicMenuItems, sidePanelWidth, isValidWabaId, isFeatureDisabled, CHRONOX_FEATURES, isWhatsAppBusinessApp, isVendor } from '../../utils/constants';
import { blackColor, imgSrcSideNavigationPanelIcon, primaryColor } from '../../utils/colors';
import CustomPageIframe from './customPageIframe';
import GlobalTooltip from '../utility/tooltip/globalTooltip';
import HelpPopup from '../utility/helpPopup';
import { useVoiceAgentStore } from '../../store/voiceAgentStore';
import { GenericDataContext, GenericDataContextPayload } from '../../context/genericDataContext';
import { homeBreadcrumb, voiceAgentBreadcrumb } from '../../utils/breadcrumb';
import { useRuleBasedInboxStore } from '../../store/ruleBasedInboxStore';
import { findWhatsAppIntegration } from '../../pages/ruleBasedInbox/utils';
import { UserMeResponseDataModel, vendorDataResponse } from '../../models/axiosModel';
import { useShallow } from 'zustand/react/shallow';


export default function Dashboard() {
    const mobileScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    const { sidePanelMenuItems, setSidePanelMenuItems, openConsultationBar, setOpenConsultationBar, flagHideConsultation, userDetail, vendorData, customPagesData, currentActiveMenu, currentActiveMobileMenu, apiRoutesPermissionAssignment, flagLoading } = React.useContext(UserContext) as UserContextPayload;
    const publicMenuItems = usePublicMenuItems(userDetail, apiRoutesPermissionAssignment)
    const { slackIntegrations, integrationListNewStructure, zohoIntegrations } = React.useContext(IntegrationContext) as IntegrationContextPayload;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const { setBreadCrumbs } = React.useContext(GenericDataContext) as GenericDataContextPayload

    const { chatClicked, chatInfoClicked } = useRuleBasedInboxStore(useShallow((store) => ({
        chatClicked: store.chatClicked,
        chatInfoClicked: store.chatInfoClicked,
    })))

    const [flagShowRequestCallbackTooltip, setFlagShowRequestCallbackTooltip] = React.useState<boolean>(true);
    const anchorRef = React.useRef<HTMLDivElement | null>(null);

    const [searchParams] = useSearchParams()
    const [flagFAB, setFlagFAB] = React.useState(true)
    let id = searchParams.get("id");
    const agentId = searchParams.get("voice_agent_id");
    const organization_id = searchParams.get('organization_id')
    const pathname = window.location.pathname.toLowerCase();

    const voiceAgentDetail = useVoiceAgentStore((state) => state.voiceAgentDetail);

    React.useEffect(() => { 
        if (userDetail?.user_organization_data?.organization_id === 2637) return;  // IT Savanna Organization.
        const timer = setTimeout(() => {
            setFlagShowRequestCallbackTooltip(false);
        }, 10000); // 10 seconds

        return () => clearTimeout(timer);
    }, [])

    const isValidId = (id: any) => {
        return id !== null && id !== undefined && id !== "" && isValidWabaId(id, integrationListNewStructure);
    }

    const currentWhatsAppIntegration = React.useMemo(() => {
        if (!Array.isArray(integrationListNewStructure) || !id) return null;
        return findWhatsAppIntegration(integrationListNewStructure, id) ?? null;
    }, [integrationListNewStructure, id]);

    const isIntegrationDataLoaded = Array.isArray(integrationListNewStructure);
    const showPaymentConfigurationMenu =
        isIntegrationDataLoaded &&
        Boolean(currentWhatsAppIntegration) &&
        !isWhatsAppBusinessApp(currentWhatsAppIntegration);

    const integrationMenuItems = [
        {
            menuName: getWabaName(integrationListNewStructure, Number(searchParams.get('id')), "WhatsApp Business"),
            menuKey: "none",
            flagHeaderKey: true,
            navigationLink: "",
            imgSrc: <img src={whatsappIcon} width={"22"} height={"22"} alt='WhatsApp' />,
            whiteImgSrc: <img src={whatsappIcon} width={"22"} height={"22"} alt='WhatsApp' />,
            coloredImgSrc: <img src={whatsappIcon} width={"22"} height={"22"} alt='WhatsApp' />,
        },
        {
            menuName: "Account Setup",
            menuKey: "account",
            navigationLink: id ? `/channels/viewintegration/whatsapp?id=${id}` : `/channels/viewintegration/whatsapp`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="account" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="account" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="account" height={"18"} width={"18"} />,
        },
        {
            menuName: "Phone Numbers",
            menuKey: "phonenumbers",
            navigationLink: `/channels/viewintegration/whatsapp/phonenumbers?id=${id}`,
            flagDisabled: isValidId(id) ? false : true,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="phoneNumber" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="phoneNumber" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="phoneNumber" height={"18"} width={"18"} />,
        },
        {
            menuName: "Template Messages",
            menuKey: "templatemessage",
            navigationLink: `/channels/viewintegration/whatsapp/templatemessages?id=${id}`,
            // flagDisabled: id ? false : true,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="templatemessage" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="templatemessage" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="templatemessage" height={"18"} width={"18"} />,
        },
        {
            menuName: "WhatsApp Flows",
            menuKey: "templateflow",
            navigationLink: `/channels/viewintegration/whatsapp/flows?id=${id}`,
            flagDisabled: isValidId(id) ? false : true,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="whatsAppFlow" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="whatsAppFlow" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="whatsAppFlow" height={"18"} width={"18"} />,
        },
        ...(showPaymentConfigurationMenu ? [{
            menuName: "Payment Configuration",
            menuKey: "paymentconfiguration",
            navigationLink: `/channels/viewintegration/whatsapp/paymentConfiguration?id=${id}`,
            flagDisabled: isValidId(id) ? false : true,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="paymentConfiguration" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="paymentConfiguration" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="paymentConfiguration" height={"18"} width={"18"} />,
        }] : []),
    ]

    const facebookIntegrationMenuItems = [
        {
            menuName: "Facebook Messenger",
            menuKey: "none",
            flagHeaderKey: true,
            navigationLink: "",
            imgSrc: <img src={facebookMessenger} width={"22"} height={"22"} alt='Facebook' />,
            whiteImgSrc: <img src={facebookMessenger} width={"22"} height={"22"} alt='Facebook' />,
            coloredImgSrc: <img src={facebookMessenger} width={"22"} height={"22"} alt='Facebook' />,
        },
        {
            menuName: "Account Setup",
            menuKey: "accountfacebook",
            navigationLink: id ? `/channels/viewintegration/facebook?id=${id}` : `/channels/viewintegration/facebook`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="account" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="account" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="account" height={"18"} width={"18"} />,
        },
    ]

    const instagramIntegrationMenuItems = [
        {
            menuName: "Instagram",
            menuKey: "none",
            flagHeaderKey: true,
            navigationLink: "",
            imgSrc: <img src={instagramIcon} width={"22"} height={"22"} alt='Instagram' />,
            whiteImgSrc: <img src={instagramIcon} width={"22"} height={"22"} alt='Instagram' />,
            coloredImgSrc: <img src={instagramIcon} width={"22"} height={"22"} alt='Instagram' />,
        },
        {
            menuName: "Account Setup",
            menuKey: "accountInstagram",
            navigationLink: id ? `/channels/viewintegration/instagram?id=${id}` : `/channels/viewintegration/instagram`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="account" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="account" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="account" height={"18"} width={"18"} />,
        },
    ]
    const slackMenuItems = [
        {
            menuName: `${slackIntegrations?.find((slackIntegration) => slackIntegration.slack_integration_id === Number(searchParams.get('id')))?.slack_team_name || "Slack Business"}`,
            menuKey: "none",
            flagHeaderKey: true,
            navigationLink: "",
            imgSrc: <IconsColor iconName="colouredSlackIcon" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor iconName="colouredSlackIcon" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor iconName="colouredSlackIcon" height={"18"} width={"18"} />,
        },
        {
            menuName: "Account Setup",
            menuKey: "accountslack",
            navigationLink: id ? `/channels/viewintegration/slack?id=${id}` : `/channels/viewintegration/slack`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="account" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="account" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="account" height={"18"} width={"18"} />,
        },
        {
            menuName: "Slack Channels",
            menuKey: "slackchannels",
            navigationLink: `/channels/viewintegration/slack/channels?id=${id}`,
            flagDisabled: id ? false : true,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="slackChannel" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="slackChannel" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="slackChannel" height={"18"} width={"18"} />,
        },

    ]
    const zohoMenuItems = [
        {
            menuName: `${zohoIntegrations?.find((zohoIntegration) => zohoIntegration.zoho_integration_id === Number(searchParams.get('id')))?.zoho_user_name || "Zoho Business"}`,
            menuKey: "none",
            flagHeaderKey: true,
            navigationLink: "",
            imgSrc: <IconsColor iconName="zoho" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor iconName="zoho" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor iconName="zoho" height={"18"} width={"18"} />,
        },
        {
            menuName: "Account Setup",
            menuKey: "accountZoho",
            navigationLink: id ? `/channels/viewintegration/zoho?id=${id}` : `/channels/viewintegration/zoho`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="account" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="account" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="account" height={"18"} width={"18"} />,
        },
    ]

    const organizationMenuItems = [
        {
            menuName: "Workspace",
            menuKey: "workspace",
            navigationLink: organization_id ? `/organization?organization_id=${organization_id}` : '/organization',
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="workspace" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="workspace" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="workspace" height={"18"} width={"18"} />,
        },
        {
            menuName: "Teams",
            menuKey: "teams",
            navigationLink: organization_id ? `/organization/teams?organization_id=${organization_id}` : '/organization/teams',
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="teamIcon" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="teamIcon" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="teamIcon" height={"18"} width={"18"} />,
        },
        ...(!isFeatureDisabled(userDetail, CHRONOX_FEATURES['THREAD_TICKETING']) ? [
            {
                menuName: "Ticket Substatus",
                menuKey: "ticketsubstatus",
                navigationLink: organization_id ? `/organization/ticketSubstatus?organization_id=${organization_id}` : '/organization',
                imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="ticketStatus" height={"18"} width={"18"} />,
                whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="ticketStatus" height={"18"} width={"18"} />,
                coloredImgSrc: <IconsColor fillColor={blackColor} iconName="ticketStatus" height={"18"} width={"18"} />,
            }
        ]: [])
    ]

    const apiKeysMenuItems = [
        {
            menuName: "API Keys",
            menuKey: "apiKeys",
            navigationLink: '/apiKeys',
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="apiKeyIcon" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="apiKeyIcon" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="apiKeyIcon" height={"18"} width={"18"} />,
        }
    ]

    
    const voiceAgentMenuItems = [
        {
            menuName: voiceAgentDetail?.voice_agent_name || "New Agent",
            menuKey: "none",
            flagHeaderKey: true,
            navigationLink: agentId ? `/voiceagent/createvoiceagent?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="voiceAgent" width="20" height="20" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="voiceAgent" width="20" height="20" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="voiceAgent" width="20" height="20" />,
        },
        {
            menuName: "Voice Agent Details",
            menuKey: "voice_agent_details",
            navigationLink: agentId ? `/voiceagent/createvoiceagent?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="voiceAgentDetail" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="voiceAgentDetail" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="voiceAgentDetail" />,
        },
        {
            menuName: "Deployments",
            menuKey: "deployments",
            navigationLink: agentId ? `/voiceagent/createvoiceagent/deployments?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent/deployments`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="voiceAgentDeployments" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="voiceAgentDeployments" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="voiceAgentDeployments" />,
            flagDisabled: !agentId
        },
        {
            menuName: "Custom API",
            menuKey: "voice_agent_custom_api",
            navigationLink: agentId ? `/voiceagent/createvoiceagent/customapi?voice_agent_id=${agentId}` : `/voiceagent/createvoiceagent/customapi`,
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="custom_api" />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="custom_api" />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="custom_api" />,
            flagDisabled: !agentId
        }
    ];

    const userSpecificMenu = [
        {
            menuName: "Dashboard",
            menuKey: "userdashboard",
            navigationLink: '/user/dashboard',
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="userDashboard" height={"15"} width={"15"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="userDashboard" height={"15"} width={"15"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="userDashboard" height={"15"} width={"15"} />,
            subMenu: customPagesData?.map((pages) => ({
                menuName: pages.custom_page_name,
                menuKey: pages.custom_page_name.toLowerCase(),
                navigationLink: pages.custom_page_slug,
                flagUserSpecific: true,
                imgSrc: <img src={pages.custom_page_icon_url} height={"16"} width={"16"} alt='' />,
                whiteImgSrc: <img src={pages.custom_page_icon_selected_url} height={"16"} width={"16"} alt='' />,
                coloredImgSrc: <img src={pages.custom_page_icon_hover_url} height={"16"} width={"16"} alt='' />
            }))
        },
    ]

    const billingUsageMenuItems = [
        {
            menuName: "Billing & Usage",
            menuKey: "billingusage",
            navigationLink: '/billing-usage',
            imgSrc: <IconsColor fillColor={imgSrcSideNavigationPanelIcon} iconName="billing" height={"18"} width={"18"} />,
            whiteImgSrc: <IconsColor fillColor={primaryColor} iconName="billing" height={"18"} width={"18"} />,
            coloredImgSrc: <IconsColor fillColor={blackColor} iconName="billing" height={"18"} width={"18"} />,
        }
    ]

    React.useEffect(() => {
        const integrationChannelsSideNavigationMenuMapping = {
            "/channels/viewintegration/facebook": facebookIntegrationMenuItems,
            "/channels/viewintegration/instagram": instagramIntegrationMenuItems,
            "/channels/viewintegration/whatsapp": integrationMenuItems,
            "/channels/viewintegration/slack": slackMenuItems,
            "/channels/viewintegration/zoho": zohoMenuItems,
            "/voiceagent/createvoiceagent": voiceAgentMenuItems
        };

        if (pathname.includes("/chatbot/viewchatbot")) {
            return;
        }

        type IntegrationChannelsRoute = keyof typeof integrationChannelsSideNavigationMenuMapping;
        const integrationChannelRoute = (Object.keys(integrationChannelsSideNavigationMenuMapping) as IntegrationChannelsRoute[]).find(route => pathname?.includes(route));

        if (integrationChannelRoute) {
            setSidePanelMenuItems(integrationChannelsSideNavigationMenuMapping[integrationChannelRoute].slice(1));
            return;
        }

        const organizationId = userDetail?.user_organization_data?.organization_id;

        let sideNavigationMenuItems;

        switch(organizationId) {
            case 2545: //sidepanels for aapdujunagadh.
                sideNavigationMenuItems = menuItemsJunagadh;
                break;
            case 2569: //sidepanels for mawhiba
                sideNavigationMenuItems = menuItemsMawhiba(userDetail, apiRoutesPermissionAssignment);
                break;
            // case 2582: //sidepanels for timsafransky
            //     sideNavigationMenuItems = menuItemsTimSafransky;
            //     if(customPagesData && customPagesData.length > 0){
            //         sideNavigationMenuItems = [...menuItemsTimSafransky, ...userSpecificMenu];
            //     }
            //     break;
            default: 
                sideNavigationMenuItems = (!userDetail?.user_assignment_role_data?.length && isOrganizationRoleAgent(userDetail)) ? [...publicAgentMenuItems] : [...publicMenuItems];
                if(customPagesData && customPagesData.length > 0){
                    sideNavigationMenuItems?.splice(sideNavigationMenuItems?.length - 1, 0, ...userSpecificMenu); // Set userSpecificMenu at last to second position 
                }
                break;
        }
        setSidePanelMenuItems(sideNavigationMenuItems);
    }, [window.location.pathname, customPagesData, integrationListNewStructure, id])

    const getSideNavigationMenuItemsByRoute = () => {
        switch(true){
            case (pathname.includes("/channels/viewintegration/facebook") && Boolean(id)):
                return facebookIntegrationMenuItems;
            case (pathname.includes("/channels/viewintegration/instagram") && Boolean(id)): 
                return instagramIntegrationMenuItems;
            case  (pathname.includes("/channels/viewintegration/whatsapp") && Boolean(id)):
                return integrationMenuItems;
            case (pathname.includes("/channels/viewintegration/slack") && Boolean(id)):
                return slackMenuItems;
            case (pathname.includes("/channels/viewintegration/zoho") && Boolean(id)):
                return zohoMenuItems;
            case pathname.includes("/organization"):
                return organizationMenuItems;
            case pathname.includes("/apikeys"):
                return apiKeysMenuItems;
            case pathname.includes("/billing-usage"):
            case pathname.includes("/plans"):
                return billingUsageMenuItems;
            case pathname.includes("/voiceagent/createvoiceagent"):
                return voiceAgentMenuItems;
            default: 
                return null;
        }
    }

    React.useEffect(() => {
        const sideNavigationMenuItems = getSideNavigationMenuItemsByRoute();
        if(sideNavigationMenuItems){
            setSidePanelMenuItems(sideNavigationMenuItems);
        }
    }, [integrationListNewStructure, slackIntegrations, zohoIntegrations, window.location.pathname, id])

    React.useEffect(() => {
        if (window.location.pathname.toLowerCase().includes("/voiceagent/createvoiceagent")) {
            setSidePanelMenuItems(voiceAgentMenuItems);
            const updatedBreadcrumbs = [
                homeBreadcrumb,
                { ...voiceAgentBreadcrumb },
                { name: voiceAgentDetail?.voice_agent_name || "Create", path: agentId ? `voiceagent/createvoiceagent?voice_agent_id=${agentId}` : `voiceagent/createvoiceagent`, isActive: true },
                // { name: tempCreateAgentPayload?.voice_agent_name || "Create", path: agentId ? `voiceagent/createvoiceagent?voice_agent_id=${agentId}` : `voiceagent/createvoiceagent`, isActive: false  }, 
            ];
            setBreadCrumbs(updatedBreadcrumbs);
        }
        else if (window.location.pathname.toLowerCase() == "/voiceagent") {
            setBreadCrumbs([])
        }
    }, [agentId, window.location.pathname, voiceAgentDetail])

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    let isDrawerClosed = searchParams.get('collapsed')
    const [open, setOpen] = React.useState(isDrawerClosed === 'true' ? false : isDrawerClosed === 'false' ? true : true);
    const handleDrawerOpen = () => {
        if(flagLoading.flagRoundLoader){
            return;
        }
        setOpen(true);
    };

    const handleDrawerClose = () => {
        if(flagLoading.flagRoundLoader){
            return;
        }
        setOpen(false);
    };
    // one tap login
    const [test, setTest] = React.useState(false);

    const handleDrawerOpentest = () => {
        setTest(!test);
    };

    const handleDrawerClosetest = () => {
        setTest(false);
    };

    const onClickOfRequestCallbackIcon = () => { 
        if(flagShowRequestCallbackTooltip){
            setFlagShowRequestCallbackTooltip(false);
        }
        setOpenConsultationBar((prev) => !prev);
    }

    const handleClickAway = () => {
        setOpenConsultationBar(false);
    }

    const shouldShowHelpIcon = (vendorData: vendorDataResponse | null, userDetail: UserMeResponseDataModel) => {
        // Vendor should not show help icon
        if(isVendor(vendorData, userDetail)){
            return false;
        }

        //  Block for IT Savanna Organization and workflow canvas page and mobile view.
        if(userDetail?.user_organization_data?.organization_id != 2637 && pathname != "/workflow/staticworkflowdetails" && !mobileScreen){
            return true;
        }
        return false;
    }

    const shouldRenderMobileHeader = () => {
        if(pathname === '/inbox' && (chatClicked || chatInfoClicked)){
            return false;
        }
        return true;
    }

    return (
        <>

            <Grid container className={globalStyles.containerflexWrapStyle}>

                {/* *****************Temp Comment For the task of : BG image for sign up popup - show the platform  {userDetail.flagUser && */}
                <Grid item sx={{ width: { sm: open ? sidePanelWidth : 70 }, flexShrink: { sm: 0 }, position: "relative" }} className={globalStyles.openSidePanel} data-side-nav-panel>
                    {open ? (
                        <img src={closeArrow} alt='close'
                            className={`${globalStyles.closeArrowStyle} ${flagLoading.flagRoundLoader ? globalStyles.disabledArrow : ""}`}
                            onClick={handleDrawerClose} />


                    ) : (
                        <img src={closeArrow} alt='close'
                            className={`${globalStyles.openArrowStyle} ${flagLoading.flagRoundLoader ? globalStyles.disabledArrow : ""}`}
                            onClick={handleDrawerOpen} />

                    )}
                    <SideNavigationPanel
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        // menuItems={userDetail.flag_user_anonymous ? menuItemsPublic : menuItemsPrivate}
                        menuItems={sidePanelMenuItems}
                        openDesktopDrawer={open}
                        handleDrawerOpen={handleDrawerOpen}
                        handleDrawerClose={handleDrawerClose}

                    />
                </Grid>
                {/* ******************************* } ****************************************************************** */}


                <Grid item className={globalStyles.fullwidth}
                // sx={{ width: { xs: "100%", sm: `calc(100% - ${open ? sidePanelWidth : 96}px)` } }}
                >
                    {shouldRenderMobileHeader() && 
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={handleDrawerToggle}
                            className={globalStyles.headerMenuIcon}
                            sx={{ marginLeft: "0px", display: { xl: "none !important", lg: "none !important", md: "none !important", sm: 'none !important' } }}

                        >
                            <MenuIcon />
                        </IconButton>
                    }

                    <Grid container className={globalStyles.columnSpaceBetween}>
                        <Grid item sx={{
                            display: { xl: "none !important", lg: "none !important", md: "none !important", sm: "none !important" } //only for mobile
                        }}>
                            {shouldRenderMobileHeader() && 
                                <Header flagShowLogo={true} menuItems={sidePanelMenuItems} />
                            }
                        </Grid>
                        <Grid item sx={{ width: mobileScreen ? "100%" : open ? `calc(100vw - ${sidePanelWidth}px) !important` : "calc(100vw - 70px) !important" }} className={`${globalStyles.dashboardMaxWidthStyles}`}>
                            <Grid container className={globalStyles.dashboardOutletWrapper}>
                                {
                                    customPagesData?.filter((data) => data.custom_page_slug === currentActiveMenu || data.custom_page_slug === currentActiveMobileMenu) && customPagesData?.filter((data) => data.custom_page_slug === currentActiveMenu || data.custom_page_slug === currentActiveMobileMenu).length > 0 ?
                                        <CustomPageIframe />
                                        :
                                        <Outlet />
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/* <Drawer sx={{
                    width: openConsultationBar ? 330 : 0,
                    flexShrink: 0,
                    transition: 'width 0.25s ease',
                    '& .MuiDrawer-paper': {
                        width: openConsultationBar ? 330 : 0,
                        transition: 'width 0.25s ease'
                    },
                }} variant='persistent' open={openConsultationBar} anchor="right">
                    <Support closeDrawer={handleDrawerClosetest} />
                </Drawer> */}
            </Grid>
            {/* {!openConsultationBar && !flagHideConsultation &&
                <>
                    <Grid item className={globalStyles.consultationWrapper}>
                        <ConsultationComponent onClickConsultation={handleDrawerOpentest} onCloseConsultation={() => { setFlagFAB(false) }} />
                    </Grid>
                </>
            } */} 
            {/* {!flagHideConsultation && 
                <Grid item className={globalStyles.consultationWrapper} ref={anchorRef}> 
                    <GlobalTooltip 
                        key={flagShowRequestCallbackTooltip ? "intro" : openConsultationBar ? "disable" : "hover"}
                        title="How can we help you today?"
                        placement='top-start'  
                        open={flagShowRequestCallbackTooltip ? true : openConsultationBar ? false : undefined}
                        arrow
                        offset={10}
                    > 
                        <span className={globalStyles.clickable} onClick={onClickOfRequestCallbackIcon}>
                            <IconsColor iconName={openConsultationBar ? "closeRequestCallbackIcon" : "requestCallbackIcon"} height={"32"} width={"32"} fillColor={"#6a097d"} />
                        </span>
                    </GlobalTooltip>
                </Grid>
            } */}
            {/* {openConsultationBar &&  */} 
                {shouldShowHelpIcon(vendorData, userDetail) &&
                    <ClickAwayListener onClickAway={handleClickAway}> 
                        <Grid item>
                            <Grid item className={globalStyles.consultationWrapper} ref={anchorRef}> 
                                <GlobalTooltip 
                                    key={flagShowRequestCallbackTooltip ? "intro" : openConsultationBar ? "disable" : "hover"}
                                    title="How can we help you today?"
                                    placement='top-start'  
                                    open={flagShowRequestCallbackTooltip ? true : openConsultationBar ? false : undefined}
                                    arrow
                                    offset={10}
                                > 
                                    <span className={globalStyles.clickable} onClick={onClickOfRequestCallbackIcon}>
                                        <IconsColor iconName={openConsultationBar ? "closeRequestCallbackIcon" : "requestCallbackIcon"} height={"32"} width={"32"} fillColor={"#6a097d"} />
                                    </span>
                                </GlobalTooltip>
                            </Grid>
                            <Popper
                                open={openConsultationBar}
                                anchorEl={anchorRef.current}
                                placement="top-start" 
                                disablePortal
                                className={globalStyles.helpPopper}
                                modifiers={[
                                    {
                                        name: 'offset',
                                        options: { offset: [0, 12] },
                                    },
                                    {
                                        name: 'flip',
                                        enabled: false,
                                    },
                                    {
                                        name: 'preventOverflow',
                                        options: { boundary: 'viewport', tether: true, altAxis: true, padding: 8 },
                                    },
                                    {
                                        name: 'eventListeners',
                                        options: { scroll: true, resize: true },
                                    },
                                ]}
                                keepMounted
                            > 
                                <HelpPopup />
                            </Popper>
                        </Grid>
                    </ClickAwayListener>
                }
            {/* } */}
        </>
    );
}
